<template>
  <div>
    <BaseError :httpCode="httpCode" :message="message" :toRoute="toRoute" />
  </div>
</template>

<script>
import BaseError from "./BaseError";

export default {
  name: "Http403",
  components: {
    BaseError,
  },
  data() {
    return {
      httpCode: 403,
      message: this.$t("errores.textos.403"),
      toRoute: {
        name: "dashboard",
        params: { tab: "claim-debt" },
        text: this.$t("errores.label.403"),
      },
    };
  },
};
</script>